import { UPDATE_MANAGER_SETTINGS } from '@/domain/arbeitszeiten/hooks/graphql/mutation';
import {
  UpdateManagerSettingsMutation,
  UpdateManagerSettingsMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useManagerSettingsUpdate() {
  const [execute, result] = useMutation<
    UpdateManagerSettingsMutation,
    UpdateManagerSettingsMutationVariables
  >(UPDATE_MANAGER_SETTINGS, {});

  const updateManagerSettings = useCallback(
    (variables: UpdateManagerSettingsMutationVariables) => {
      return execute({
        variables,
      });
    },
    [execute],
  );

  return {
    updateManagerSettings,
    result,
  };
}
